import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Container, Spinner } from '@treams/treams-ui';

import ExternalMenu from '../../../../../navigation/ExternalMenu';
import FeedbackRespondInstructions from './FeedbackRespondInstructions';
import FeedbackResponseComposer from './FeedbackResponseComposer';
import FeedbackThankYou from './FeedbackThankYou';

function ExternalFeedbackResponseComposerContents(props: { responseID: string; secret: string }) {
	const response = graphql.useExternalFeedbackQuery({
		variables: {
			id: props.responseID,
			secret: props.secret,
		},
	});

	if (response.data) {
		return (
			<FeedbackResponseComposer
				response={response.data.externalFeedback as graphql.FeedbackResponse}
				secret={props.secret}
			/>
		);
	} else if (response.error) {
		return <FeedbackThankYou external />;
	} else {
		return <Spinner centered />;
	}
}

export default function ExternalFeedbackResponseComposer(props: {
	responseID: string;
	secret: string;
}) {
	return (
		<Box>
			<ExternalMenu />
			<Container wide={1180}>
				<Flex justifyContent="center" flexWrap="wrap">
					<Box mx={2} my={[4, 4, 5]} width={[1, 1, 6 / 12]}>
						<ExternalFeedbackResponseComposerContents
							responseID={props.responseID}
							secret={props.secret}
						/>
					</Box>

					<Box width={[1, 1, 3 / 12]} p={[0, 0, 4]} pb={[4, 4, 0]} mx={2}>
						<FeedbackRespondInstructions />
					</Box>
				</Flex>
			</Container>
		</Box>
	);
}
